import React, { useEffect, useRef, useState } from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const AiOsSuggestionModal = ({ open, onClose, ticket, onSuggestionReady }) => {
  const [loading, setLoading] = useState(false);
  const [suggestion, setSuggestion] = useState(null);
  const ticketRef = useRef(null);

  useEffect(() => {
    if (!open || !ticket?.id) return undefined;

    // Snapshot do ticket no momento da abertura: mensagens novas que chegam
    // enquanto o modal está aberto não devem disparar outra requisição.
    ticketRef.current = ticket;

    let active = true;
    setSuggestion(null);
    setLoading(true);

    api.post(`/tickets/${ticketRef.current.id}/os/ai-suggestion`)
      .then(({ data }) => {
        if (active) setSuggestion(data.data || data);
      })
      .catch(err => {
        if (active) {
          toastError(err);
          onClose();
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleUseSuggestion = () => {
    if (!suggestion) return;
    onSuggestionReady(suggestion);
    onClose();
  };

  const confidence = suggestion
    ? `${Math.round(Number(suggestion.confidence || 0) * 100)}%`
    : "-";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Sugestão de OS com IA</DialogTitle>
      <DialogContent dividers>
        {loading && (
          <div style={{ textAlign: "center", padding: 32 }}>
            <CircularProgress />
            <Typography variant="body2" style={{ marginTop: 16 }}>
              Analisando a conversa e os cadastros da OS...
            </Typography>
          </div>
        )}
        {!loading && suggestion && (
          <>
            <Typography variant="body2" color="textSecondary">
              Confiança estimada: <strong>{confidence}</strong>
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Modelo: {suggestion.model || "-"}
            </Typography>
            <Typography variant="body2" style={{ marginTop: 12 }}>
              {suggestion.reason || "A IA não informou uma justificativa."}
            </Typography>
            <Divider style={{ margin: "16px 0" }} />
            <Typography variant="caption" color="textSecondary">
              Descrição curta sugerida
            </Typography>
            <Typography variant="body1" gutterBottom>
              {suggestion.descricao_curta || "Não identificada"}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Descrição sugerida
            </Typography>
            <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
              {suggestion.descricao || "Não identificada"}
            </Typography>
            {!suggestion.should_create && (
              <Typography variant="body2" color="error" style={{ marginTop: 16 }}>
                A IA não encontrou segurança suficiente para criar esta OS. Você ainda pode abrir o formulário e completar a classificação manualmente.
              </Typography>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleUseSuggestion} color="primary" variant="contained" disabled={loading || !suggestion}>
          Abrir formulário para revisar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AiOsSuggestionModal;
